// Import utils
import { CCCLinkList, LinkListItem } from "../components/link-list/index";

// Components to use
import "../components/html-panel/index";
import { CustomElement } from "../core/CustomElement";
import { VanillaPagesType } from "../core/types/VanillaPages";
import { selectAnchor } from "../core/utilities";
import OContentModel from "../models/OContentModel";

export interface QuicklinksInitOptions {
  anchor: string;
  catName: string;
}
export default class QuickLinksController {
  public $quickLinksComponent: CCCLinkList = null;
  public $panel: CustomElement = null;

  init(type: VanillaPagesType, options?: QuicklinksInitOptions): void {
    switch (type) {
      case VanillaPagesType.discussions:
        this._initForDiscussions(options);
        break;
      default:
        throw "Quick Links - Not a valid type";
        break;
    }
  }

  private async _initForDiscussions(
    options: QuicklinksInitOptions
  ): Promise<void> {
    this.$panel = <CustomElement>selectAnchor(options.anchor);
    if (this.$panel) {
      try {
        // load the dom anchor
        this.$quickLinksComponent = <CCCLinkList>(
          selectAnchor("ccc-link-list", this.$panel)
        );
        this.setLoading(true);
        // load the Leaderboard data, separated by level
        const links = await OContentModel.getQuickLinksData(options.catName);
        if (links.length > 0) {
          this.updateLinks(links);
          this.setLoading(false);
        } else {
          this.$panel.hide();
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      console.error(`Quick Links - ${options.anchor} element not found in DOM`);
    }
  }

  setLoading(visible: boolean): void {
    this.$quickLinksComponent.loading = visible;
  }

  updateLinks(links: LinkListItem[]): void {
    // need to be set before the links
    this.$quickLinksComponent.setKeyState("emptyListMsg", "Nothing here");
    this.$quickLinksComponent.setKeyState("links", links);
  }
}
